/**
 * Auto-sliding banner carousel
 * ============================
 * Shared by sections/full-width-image.liquid and sections/image-banner.liquid.
 * A root element carries [data-autoslider] plus data-interval (seconds per
 * slide); inside it, .autoslider__track holds one .autoslider__slide per
 * image and the track slides across via translateX. Optional .autoslider__dot
 * buttons jump straight to a slide.
 *
 * Behavior:
 *   - advances automatically every data-interval seconds, looping forever;
 *   - pauses while hovered or keyboard-focused (so links stay clickable);
 *   - skips ticks while the tab is hidden;
 *   - prefers-reduced-motion is honored in banner-autoslider.css (the
 *     transition is disabled — slides still change, they just don't animate).
 */
(function () {
  'use strict';

  function initSlider(root) {
    /* Guard against double-init (initAll runs on DOMContentLoaded AND on
       every shopify:section:load re-render in the theme editor). */
    if (root.dataset.autosliderInit === 'true') return;
    root.dataset.autosliderInit = 'true';

    var track = root.querySelector('.autoslider__track');
    if (!track) return;
    var slides = track.children;
    if (slides.length < 2) return;

    var intervalMs = (parseFloat(root.dataset.interval) || 5) * 1000;
    var dots = root.querySelectorAll('.autoslider__dot');
    var index = 0;
    var timer = null;

    function goTo(i) {
      index = ((i % slides.length) + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      for (var d = 0; d < dots.length; d++) {
        if (d === index) {
          dots[d].setAttribute('aria-current', 'true');
        } else {
          dots[d].removeAttribute('aria-current');
        }
      }
    }

    function stop() {
      if (timer !== null) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      timer = setInterval(function () {
        if (!document.hidden) goTo(index + 1);
      }, intervalMs);
    }

    for (var d = 0; d < dots.length; d++) {
      (function (i) {
        dots[i].addEventListener('click', function () {
          goTo(i);
          start(); /* restart the countdown from the clicked slide */
        });
      })(d);
    }

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);

    /* Exposed for the theme-editor block select/deselect handlers below. */
    root.__autoslider = { goTo: goTo, start: start, stop: stop };

    start();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-autoslider]');
    for (var i = 0; i < roots.length; i++) initSlider(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Theme editor: sections re-render with fresh DOM — init the new copy. */
  document.addEventListener('shopify:section:load', initAll);

  /* Theme editor: clicking an Image slide block shows that slide (and holds
     it there); deselecting resumes the rotation. */
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target && e.target.closest ? e.target.closest('.autoslider__slide') : null;
    if (!slide) return;
    var root = slide.closest('[data-autoslider]');
    if (!root || !root.__autoslider) return;
    root.__autoslider.stop();
    var slides = root.querySelector('.autoslider__track').children;
    for (var i = 0; i < slides.length; i++) {
      if (slides[i] === slide) {
        root.__autoslider.goTo(i);
        break;
      }
    }
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    var slide = e.target && e.target.closest ? e.target.closest('.autoslider__slide') : null;
    if (!slide) return;
    var root = slide.closest('[data-autoslider]');
    if (root && root.__autoslider) root.__autoslider.start();
  });
})();
